import React from 'react';
import styles from './typography.module.css';

type TitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  $mobileColor?: string;
  $desktopColor?: string;
};

export const UHClueTitle = React.forwardRef<HTMLHeadingElement, TitleProps>(
  function UHClueTitle(
    { className, style, $mobileColor, $desktopColor, ...rest },
    ref,
  ) {
    const mobileColor = $mobileColor ?? '#000';
    const desktopColor = $desktopColor ?? $mobileColor ?? '#000';
    return (
      <h2
        ref={ref}
        className={className ? `${styles.title} ${className}` : styles.title}
        style={
          {
            ['--uhc-title-color-m' as string]: mobileColor,
            ['--uhc-title-color-d' as string]: desktopColor,
            ...style,
          } as React.CSSProperties
        }
        {...rest}
      />
    );
  },
);

type SubtitleProps = React.HTMLAttributes<HTMLParagraphElement> & {
  $color?: string;
};

export const UHClueSubtitle = React.forwardRef<
  HTMLParagraphElement,
  SubtitleProps
>(function UHClueSubtitle({ className, style, $color, ...rest }, ref) {
  return (
    <p
      ref={ref}
      className={className ? `${styles.subtitle} ${className}` : styles.subtitle}
      style={
        {
          ['--uhc-subtitle-color' as string]: $color ?? 'rgba(0, 0, 0, 0.6)',
          ...style,
        } as React.CSSProperties
      }
      {...rest}
    />
  );
});

type BodyProps = React.HTMLAttributes<HTMLParagraphElement> & {
  $color?: string;
};

export const UHClueBody = React.forwardRef<HTMLParagraphElement, BodyProps>(
  function UHClueBody({ className, style, $color, ...rest }, ref) {
    return (
      <p
        ref={ref}
        className={className ? `${styles.body} ${className}` : styles.body}
        style={
          {
            ['--uhc-body-color' as string]: $color ?? 'rgba(0, 0, 0, 0.6)',
            ...style,
          } as React.CSSProperties
        }
        {...rest}
      />
    );
  },
);
